<template>
  <span>
    <div class="segmented-control">
      <div
        v-for="option in options"
        class="segmented-control__option"
        tabindex="0"
        :class="{
          'segmented-control__option--selected': inputValue === option.value,
        }"
        :key="option.displayValue"
        @click="inputValue = option.value"
        @keydown.enter.prevent="inputValue = option.value"
        @keydown.space.prevent="inputValue = option.value"
      >
        {{ option.displayValue }}
      </div>
    </div>
    <ValidationMessage
      :displayInvalid="displayInvalid"
      :validation-message="externalValidationErrorMessage || validationMessage"
    />
  </span>
</template>

<script>
import BaseComponent from "../../BaseComponent";
import InputBase from "./mixins/InputBase";

/**
 * @group Inputs
 * Same functionallity as a radio list. However, these options are displayed next to each other
 * there is also no radio button, instead the whole background turns a different colour when option
 * is selected.
 */
export default {
  mixins: [BaseComponent, InputBase],
  name: "SegmentedControl",
  data() {
    return {
      selectedOption: this.options.find((option) => option.selected),
    };
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    validationMessage: {
      type: String,
      default: "Please select an option",
    },
    enableExternalValidation: {
      type: Boolean,
      default: false,
    },
    externalValidationError: {
      type: Boolean,
    },
    externalValidationErrorMessage: {
      type: String,
    },
  },
  computed: {
    displayInvalid() {
      if (this.enableExternalValidation) return this.externalValidationError;
      return this.isShowingValidationMessage && !this.isValid;
    },
    isValid() {
      return (this.required && this.value !== "") || !this.required;
    },
  },
  methods: {
    // Checks if @option is the selected option.
    isOptionSelected(option) {
      return JSON.stringify(this.selectedOption) === JSON.stringify(option);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../style_variables/style_variables.scss";

.segmented-control {
  display: inline-flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid $blue;
  border-radius: 4px;
  overflow: hidden;
}
.segmented-control__option {
  @extend %body2_style;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: $input_max_width;
  height: 36px;
  border-right: 1px solid $blue;
  &:hover {
    cursor: pointer;
    background-color: $grey_alabaster;
  }
  &:nth-last-of-type(1) {
    border-right: 0px;
  }
  &.segmented-control__option--selected {
    color: $white;
    background-color: $blue;
  }
}
</style>
